export default "__VITE_ASSET__B0dtOVG$__"